export const cor1 = "#3c3e44";
export const cor2 = "#272b33";
export const cor3 = "#202329";
export const font = "'Prompt', sans-serif;";
export const font2 = "'Skranji', cursive;";
